import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import DatePicker from "react-datepicker";
import RightArrow from "../../../assets/user/images/right-arow.png";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../../layouts/loader/Loader";
import { routes } from "../../../utlis/user/routes.utlis";
import { api } from "../../../utlis/user/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { communityLIMIT, totalPageCalculator } from "../../../utlis/common.utlis";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Modal, ModalBody } from "react-bootstrap";
import moment from "moment";
import { encode } from "base-64";

const SuggestedList = () => {
  const navigate = useNavigate();
  const [list, setSuggestedList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [unfollow, setUnfollow] = useState({
    status: false,
    id: null,
  });

  const getSuggestedList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("suggested listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setSuggestedList(response.data.data.communityList);
      setTotal(response.data.data.total);
    } else setSuggestedList([]);
    setLoading(false);
  };

  const followCommunity = async (id) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(
      api.communityFollow + `${id}`
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getSuggestedList(
        api.communitySuggested + `?page=${pageNum}&limit=${communityLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const unFollowCommunity = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityUnFollow + `${unfollow.id}`
    );
    setUnfollow({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getSuggestedList(
        api.communitySuggested + `?page=${pageNum}&limit=${communityLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("MM/DD/yyyy");
    else date = "";
    getSuggestedList(
      api.communitySuggested +
        `?page=${pageNum}&limit=${communityLIMIT}&search=${name}&date=${date}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getSuggestedList(
      api.communitySuggested + `?page=${pageNum}&limit=${communityLIMIT}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="community--details-info">
          <div className="community-title-header">
            <h2 className="heading-title">Suggested Community</h2>
            <div className="search-filter wd30">
              <div className="row g-2">
                <div className="col-md-3">
                  <Link
                    className="btn-gr wd100"
                    to=""
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Link>
                </div>
                <div className="col-md-9">
                  <div className="form-group mb-0">
                    <div className="search-form-group">
                      <input
                        type="text"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                        className="form-control"
                        placeholder="Search By Community Name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {list?.length !== 0 &&
            list !== "" &&
            list !== null &&
            list !== undefined ? (
              list?.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="community-card">
                      <div className="community-head">
                        <div className="community-head-media">
                          {ele.profile_image === null ||
                          ele.profile_image === "" ||
                          ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" />
                          ) : (
                            <img src={ele.profile_image} alt="" />
                          )}
                        </div>
                        <div className="community-head-content text-capitalize">
                          <h4>{ele.fullname ?? "NA"}</h4>
                        </div>
                        <div className="community-head-action">
                          {ele.is_following == "false" ? (
                            <Link
                              className="Follow-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                followCommunity(ele.id);
                              }}
                            >
                              Follow
                            </Link>
                          ) : (
                            <Link
                              className="UnFollow-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                setUnfollow({
                                  status: true,
                                  id: ele.id,
                                });
                              }}
                            >
                              Unfollow
                            </Link>
                          )}
                          <Link
                            className="view-font-btn"
                            style={{ width: "31px", height: "31px" }}
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.communityInfo, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <img width={19} src={RightArrow} />
                          </Link>
                        </div>
                      </div>
                      <div className="community-image">
                        <CarouselProvider
                          id="Main-Slider"
                          naturalSlideWidth={100}
                          naturalSlideHeight={50}
                          totalSlides={
                            ele.cover_image.length !== 0
                              ? ele.cover_image.length
                              : 1
                          }
                          isPlaying={true}
                        >
                          <Slider>
                            {ele.cover_image.length !== 0 ||
                            ele.cover_image !== null ||
                            ele.cover_image !== "" ||
                            ele.cover_image !== undefined ? (
                              ele.cover_image.map((ele, indx) => {
                                return (
                                  <Slide key={indx} index={indx}>
                                    <div className="item">
                                      <div className="Main-Slider-media">
                                        <img src={ele.image} alt="Cover" />
                                      </div>
                                    </div>
                                  </Slide>
                                );
                              })
                            ) : (
                              <img src={NoImage} alt="" />
                            )}
                          </Slider>
                        </CarouselProvider>
                      </div>
                      <div className="community-content">
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <p>{ele.description ?? "NA"}</p>
                        <div className="community-folllow-user">
                          <div className="community-folllow-media">
                            {ele?.last_following_member_images?.length !== 0 ? (
                              ele?.last_following_member_images?.map(
                                (element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        "folllow-user-image image" +
                                        `${index + 1}`
                                      }
                                    >
                                      {element === null ||
                                      element === "" ||
                                      element === undefined ? (
                                        <img src={NoImage} alt="No profile" />
                                      ) : (
                                        <img
                                          src={element}
                                          alt={`Member ${index + 1}`}
                                        />
                                      )}
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="folllow-user-image image1">
                                <img src={NoImage} alt="No profile" />
                              </div>
                            )}
                          </div>
                          <div className="folllow-user-text">
                            {ele.member_count ?? 0} Followers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3">
            {list?.length !== 0 ? (
              <div className="care-table-pagination">
                <ul className="care-pagination">
                  {pageNum !== 1 && (
                    <li
                      className="disabled"
                      id="example_previous"
                      onClick={() => setPageNum(pageNum - 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="0"
                        tabIndex="0"
                        className="page-link"
                      >
                        Previous
                      </Link>
                    </li>
                  )}

                  {totalPageCalculator(total, communityLIMIT).length === 1
                    ? null
                    : totalPageCalculator(total, communityLIMIT).map((pageNo, indx) => {
                        return (
                          <li
                            className={pageNo === pageNum ? "active" : ""}
                            key={indx}
                            onClick={() => setPageNum(pageNo)}
                          >
                            <Link to="" className="page-link">
                              {pageNo}
                            </Link>
                          </li>
                        );
                      })}

                  {pageNum !== Math.ceil(total / communityLIMIT) && (
                    <li
                      className="next"
                      id="example_next"
                      onClick={() => setPageNum(pageNum + 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="7"
                        tabIndex="0"
                        className="page-link"
                      >
                        Next
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        show={unfollow.status}
        onHide={() => {
          setUnfollow({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Unfollow Community</h5>
                <p className="text-center">
                  Are you sure you want to unfollow this community?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setUnfollow({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => unFollowCommunity()}
                >
                  Yes! Unfollow
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default SuggestedList;
